/* LW24 V6 · Mouse-Follower-Glow für .lw-ai-glow Container (Influvera-DNA)
 *
 * ⚠️ UMGEBAUT AM 12.08.2026 — der Effekt hat das Scrollen ausgebremst.
 * Von Max: "das wirkt nicht so smooth ... ich habe MacBook Pro 120 Hz und
 * es wirkt nicht flüssig."
 *
 * Die alte Fassung rief bei JEDEM mousemove getBoundingClientRect() auf und
 * schrieb danach sofort zwei Style-Werte. Beides zusammen ist der klassische
 * Layout-Thrash: das Lesen zwingt den Browser, ein angefangenes Layout
 * sofort fertigzurechnen, das folgende Schreiben macht es wieder ungültig -
 * und das pro Mausbewegung. Auf einem Trackpad kommen davon sehr viele, auch
 * während man scrollt, weil der Zeiger dabei über der Seite steht.
 *
 * Drei Änderungen:
 *   1. Kein getBoundingClientRect mehr im Ereignis. offsetX/offsetY liefern
 *      dieselbe Position relativ zum Element, ohne Layout zu lesen.
 *   2. Geschrieben wird höchstens einmal pro Bild (requestAnimationFrame).
 *      Mehr als ein Wert pro Bild ist ohnehin nicht sichtbar.
 *   3. passive: true - der Zuhörer ruft nie preventDefault, und der Browser
 *      muss dann nicht auf ihn warten.
 *
 * ⚠️ Wer hier wieder eine Messung ins Ereignis schreibt, holt das Ruckeln
 * zurück. Messen gehört in ein rAF oder gar nicht.
 */
(function () {
  function init() {
    var nodes = document.querySelectorAll('.lw-ai-glow');
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      var follower = el.querySelector('.lw-ai-glow__follower');
      if (!follower) return;
      var x = 0, y = 0, geplant = false;
      el.addEventListener('mousemove', function (e) {
        /* offsetX/offsetY sind bereits relativ zum Element unter dem Zeiger.
           Liegt ein Kind darunter, rechnen wir dessen Versatz dazu - ohne
           getBoundingClientRect, also ohne erzwungenes Layout. */
        x = e.offsetX;
        y = e.offsetY;
        var t = e.target;
        while (t && t !== el) { x += t.offsetLeft; y += t.offsetTop; t = t.offsetParent; }
        if (geplant) return;
        geplant = true;
        window.requestAnimationFrame(function () {
          geplant = false;
          follower.style.left = x + 'px';
          follower.style.top = y + 'px';
        });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
